import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { ThemeProps } from "../../models/theme";
import { ErrorResponse } from "../../models/apiResponse";

const useQueryTheme = ({
  corporateName,
  enabled = true,
  authorisation = "",
}: {
  corporateName: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    ["theme"],
    () =>
      fetchApi(`theme/by-url/${corporateName}`, {
        headers: {
          Authorization: `Bearer ${authorisation}`, // Pass token here
        },
      }).get<ThemeProps | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryTheme;
